import React, { useContext, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { AppContext } from "../utils";
import {
  Hidden,
  Container,
  useMediaQuery,
  SwipeableDrawer,
  Button,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { Link } from "react-router-dom";
import logo from "../images/logo1.png";

import { makeStyles } from "@mui/styles";
import MenuIcon from "@mui/icons-material/Menu";
import clsx from "clsx";
import { Paper } from "@mui/material";
import { UseSalesContract } from "../ConnectivityAss/hooks";

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
    alignItems: "center",
  },
  paper: {
    background: "#1C0D38 !important",
    justifyContent: "center",
  },
  hover: {
    "&:hover": {
      color: "#FFB800",
    },
  },
});

export default function Header(props) {
  const { account, connect, disconnect, signer } = useContext(AppContext);
  const salesContract = UseSalesContract(signer);
  const classes = useStyles();
  const [state, setState] = React.useState({
    left: false,
  });

  const matches = useMediaQuery("(max-width:960px)");
  const matches1 = useMediaQuery("(max-width:1279px)");
  const [ownerAdd, setownerAdd] = useState();
  const [user, setuser] = useState("");
  const init = async () => {
    try {
      const owner = await salesContract.admin();
      let addressOwner = owner.toLowerCase();
      setownerAdd(addressOwner);
      let add = account.toLowerCase();
      setuser(add);
    } catch (error) {}
  };
  useEffect(() => {
    init();
  }, [salesContract, account]);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };
  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Box mt={-40} display="flex" justifyContent="center">
        <img width="220px" src="/logo1.png" alt="" />
      </Box>
      <List>
        {["projects", "staking"].map((text, index) => (
          <ListItem
            button
            style={{
              justifyContent: "center",
              borderBottom: "1px solid #bbb8b8",
            }}
            key={text}
          >
            <Link
              style={{
                textDecoration: "none",
                color: "#ffffff",
              }}
              to={`/${text}`}
            >
              <ListItemText>
                <Box
                  style={{
                    textDecoration: "none",
                    textTransform: "capitalize",
                    textAlign: "center",
                    textDecoration: "none",
                    cursor: "pointer",
                    color: "#ffffff",
                    fontFamily: "Raleway",
                    fontWeight: "500",
                    fontSize: "18px",
                  }}
                >
                  {text}
                </Box>
              </ListItemText>
            </Link>
          </ListItem>
        ))}
      </List>
      {user == ownerAdd ? (
        <Box
          pb={1}
          borderBottom="1px solid #ffffff"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Link
            to="/ido"
            style={{
              textTransform: "capitalize",
              textAlign: "center",
              textDecoration: "none",
              cursor: "pointer",
              color: "#ffffff",
              fontFamily: "Raleway",
              fontWeight: "500",
              fontSize: "18px",
            }}
          >
            IDO
          </Link>
        </Box>
      ) : null}

      <Box my={1} display="flex" justifyContent="center">
        {account ? (
          <Box
            width="90%"
            height="52px"
            borderRadius="25px"
            sx={{ cursor: "pointer" }}
            display="flex"
            justifyContent="center"
            alignItems="center"
            color="#ffffff"
            fontFamily="Open Sans"
            fontWeight="500"
            fontSize="16px"
            onClick={() => disconnect()}
            style={{
              zIndex: 1,
              background: "linear-gradient(360deg, #26058E 50%, #A301F7)",
            }}
          >
            {account.slice(0, 4) + "..." + account.slice(-4)}
          </Box>
        ) : (
          <Box
            zIndex={1}
            style={{
              cursor: "pointer",
              background: "linear-gradient(360deg, #26058E 50%, #A301F7)",
            }}
            width="90%"
            height="52px"
            fontWeight="500"
            borderRadius="25px"
            fontSize="20px"
            color="#ffffff"
            fontFamily="Raleway"
            display="flex"
            justifyContent="center"
            alignItems="center"
            onClick={() => connect()}
          >
            Connect
          </Box>
        )}
      </Box>
    </div>
  );

  return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        style={{
          background: "#1C0D38",
          zIndex: "100px",
        }}
        height="92px"
        width="100%"
      >
        <Container maxWidth="xl">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            pl={matches ? 0 : 5}
            pr={matches ? 0 : 5}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              // flexBasis="20%"
            >
              <Box
                style={{
                  textDecoration: "none",
                  cursor: "pointer",
                }}
              >
                <img width="200px" src={logo} alt="" />
              </Box>
            </Box>
            <Box
              display="flex"
              justifyContent={matches1 ? "end" : "space-between"}
              alignItems="center"
              // flexBasis={matches1 ? "45px" : "78%"}
            >
              <Box
                display="flex"
                justifyContent="space-around"
                // flexBasis={matches1 ? "0px" : "70%"}
                alignItems="center"
              >
                <Hidden mdDown>
                  <Link to="/" style={{ textDecoration: "none", padding: "0" }}>
                    <Box
                      mr={6}
                      fontSize="19px"
                      fontWeight="700"
                      fontFamily="Raleway"
                      style={{
                        cursor: "pointer",
                        color: "#fff",
                      }}
                    >
                      Projects
                    </Box>
                  </Link>
                  <Link
                    to="/staking"
                    style={{ textDecoration: "none", padding: "0" }}
                  >
                    <Box
                      mr={6}
                      fontSize="19px"
                      fontWeight="700"
                      fontFamily="Raleway"
                      zIndex="1"
                      style={{
                        cursor: "pointer",
                        color: "#fff",
                      }}
                    >
                      Staking
                    </Box>
                  </Link>
                  {/* {user == ownerAdd ? ( */}
                  <Link
                    to="/ido"
                    style={{ textDecoration: "none", padding: "0" }}
                  >
                    <Box
                      mr={6}
                      fontSize="19px"
                      fontWeight="700"
                      fontFamily="Raleway"
                      zIndex="1"
                      style={{
                        cursor: "pointer",
                        color: "#ffffff",
                      }}
                    >
                      IDO
                    </Box>
                  </Link>
                  {/* ) : null} */}

                  {account ? (
                    <Box
                      width="150px"
                      height="52px"
                      borderRadius="25px"
                      sx={{ cursor: "pointer" }}
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      color="#ffffff"
                      fontWeight="400"
                      fontSize="16px"
                      onClick={() => disconnect()}
                      fontFamily="Open Sans"
                      style={{
                        zIndex: 1,
                        background:
                          "linear-gradient(360deg, #26058E 50%, #A301F7)",
                      }}
                    >
                      {account.slice(0, 4) + "..." + account.slice(-4)}
                    </Box>
                  ) : (
                    <Box
                      zIndex={1}
                      style={{
                        cursor: "pointer",
                        background:
                          "linear-gradient(360deg, #26058E 50%, #A301F7)",
                      }}
                      width="150px"
                      height="52px"
                      fontWeight="500"
                      borderRadius="25px"
                      fontSize="20px"
                      color="#ffffff"
                      fontFamily="Raleway"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      onClick={() => connect()}
                    >
                      Connect
                    </Box>
                  )}
                </Hidden>
              </Box>

              <Hidden mdUp>
                {["left"].map((anchor) => (
                  <React.Fragment key={anchor}>
                    <Button
                      onClick={toggleDrawer(anchor, true)}
                      style={{ zIndex: 1 }}
                    >
                      <MenuIcon
                        style={{
                          fontSize: "38px",
                          cursor: "pointer",
                          color: "#ffffff",
                        }}
                      ></MenuIcon>
                    </Button>
                    <Paper style={{ background: "#1C0D38" }}>
                      <SwipeableDrawer
                        classes={{ paper: classes.paper }}
                        anchor={anchor}
                        open={state[anchor]}
                        onClose={toggleDrawer(anchor, false)}
                        onOpen={toggleDrawer(anchor, true)}
                      >
                        {list(anchor)}
                      </SwipeableDrawer>
                    </Paper>
                  </React.Fragment>
                ))}
              </Hidden>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
}
